import 'angular';

import { EmailJobCardCtrl }             from './messages.email-job-card';
import { EmailVendorInvoiceCtrl }       from './messages.email-vendor-invoice';
import { MessagesResolver }             from './messages.resolver.ajs';
import { MessagesStates }               from './messages.states.ajs';
import { RemindersCtrl }                from './messages.reminders.ajs';
import { SearchEmailAddressModalCtrl }  from './messages.search-email-address-modal';

angular.module('workshop.messages', [])
.controller('emailJobCardCtrl',            EmailJobCardCtrl)
.controller('emailVendorInvoiceCtrl',      EmailVendorInvoiceCtrl)
.controller('RemindersCtrl',               RemindersCtrl)
.controller('SearchEmailAddressModalCtrl', SearchEmailAddressModalCtrl)
.config(MessagesStates)
.run(MessagesResolver);